import * as React from "react"
import Button from "../Button/Button"
import { ContactStyles } from "./ContactStyles"

const Contact = () => {
  return (
    <ContactStyles className="section">
      <form name="contact" netlify>
        <input placeholder="Twoje imię..." type="text" name="name" />
        <input placeholder="Adres e-mail..." type="email" name="email" />
        <textarea
          placeholder="Twoja wiadomość..."
          name="message"
          rows="5"
        ></textarea>
        <Button text="Wyślij" />
      </form>
    </ContactStyles>
  )
}

export default Contact
